/**
 * This program is free software; you can redistribute it and/or
 * modify it under the terms of the GNU General Public License
 * as published by the Free Software Foundation; under version 2
 * of the License (non-upgradable).
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU General Public License for more details.
 *
 * You should have received a copy of the GNU General Public License
 * along with this program; if not, write to the Free Software
 * Foundation, Inc., 51 Franklin Street, Fifth Floor, Boston, MA  02110-1301, USA.
 *
 * Copyright (c) 2023 (original work) Open Assessment Technologies SA
 */

import pageController from '@/core/page/page.js';
import { selectedInteractions as selectedInteractionsStore } from '@/store/interactions.js';
import { get } from 'svelte/store';
import { routes, actionsList } from '@/core/utils/consts.js';
import { postAuthorize } from '@/core/api/api.js';
import { interactionsToAcs } from '@/core/utils/interactions.js';

export default () =>
    // eslint-disable-next-line implicit-arrow-linebreak
    pageController({
        name: 'authorize',
        /**
         * Checks if selectedInteractionsStore contains a valid interaction,
         * or redirects to home page if that is not the case
         */
        start() {
            // Authorize is different from other actions; it has no visual component.
            // It just posts and redirects
            const selected = get(selectedInteractionsStore);
            if (selected.length) {
                const selectedAsAcs = interactionsToAcs(selected, actionsList.authorize);
                postAuthorize(selectedAsAcs);
            }
            this.router.redirect(routes.home);
        }
    });
